import ImageCropModal from 'adv/campaign/components/common/ImageCropModal'
import LogoUpload from 'adv/campaign/components/common/LogoUpload'
import TextInput from 'adv/campaign/components/common/TextInput'
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Form, Row, Col } from 'react-bootstrap'
import Select from 'react-select'
import loadMultipleImages from '@services/micro/load_multiple_images'
import { getDimensions } from '@helpers/get-dimensions'
import { loadImages } from '@services/micro'

const CONTENT_TYPES = [
    {
        value: 1,
        label: 'eBook'
    },
    {
        value: 2,
        label: 'Webinar'
    },
    {
        value: 3,
        label: 'Case Study'
    }
]

export const CustomizeAdTab = memo(({ landingPageUrl, inventoryCampaign, onChangeCustomUrl, setInventoryCampaign }) => {
    const contentTypes = CONTENT_TYPES
    const dimensionsToUse = useMemo(() => getDimensions(inventoryCampaign), [inventoryCampaign])

    const [isImageCropModal, setIsImageCropModal] = useState(false)
    const [imageFiles, setImageFiles] = useState(null)
    const [croppedImagePreview, setCroppedImagePreview] = useState(null)

    const getImages = useCallback(async () => {
        if (!inventoryCampaign?.img_lg || !inventoryCampaign?.img_sm) return

        const images = await loadMultipleImages([inventoryCampaign.img_lg, inventoryCampaign.img_sm])

        if (images && images?.length > 0) {
            setCroppedImagePreview(images.find(image => image.url)?.url)
            if (document.getElementById('logo-input-placeholder')) {
                document.getElementById('logo-input-placeholder').innerText = 'Content Image loaded'
            }
        }
    }, [inventoryCampaign?.img_lg, inventoryCampaign?.img_sm])

    useEffect(() => {
        getImages()
    }, [getImages])

    const logoInputRef = useRef(null)

    const handleSaveCroppedImages = async (croppedFile) => {
        const objectUrl = URL.createObjectURL(croppedFile[0])
        const logoRequest = await loadImages([croppedFile[0],croppedFile[1]])
            if (logoRequest?.success) {
                setInventoryCampaign({ ...inventoryCampaign, img_lg: logoRequest.data[0].id, img_sm: logoRequest.data[1].id })
            }
        setCroppedImagePreview(objectUrl)
        
        document.getElementById('logo-input-placeholder').innerText = 'Content Image loaded'
    }

    const onLogoChange = async e => {
        if (e.target.files.length > 0) {
            const files = Array.from(e.target.files)

            setIsImageCropModal(true)
            setImageFiles(files)


            // this is hotfix. remove if it is in production
            // const { validFiles } = await validateImageDimensions(files, dimensionsToUse[0])

            // if (validFiles.length > 0) {
            //     setIsImageCropModal(true)
            //     setImageFiles(validFiles)
            // }

            e.target.value = null
        }
    }

    return (
        <>
            {/* {isLoading && <LoaderWithBlur publisherByAbbr={68} content="Saving your ad. This may take several seconds..." />} */}
            {isImageCropModal && (
                <ImageCropModal
                    modalShow={isImageCropModal}
                    modalHandleClose={() => setIsImageCropModal(false)}
                    imageFiles={imageFiles}
                    onSave={handleSaveCroppedImages}
                    dimensions={dimensionsToUse[0]}
                    secondaryDimensions={dimensionsToUse[1]}
                    ref={logoInputRef}
                />
            )}
            <Col sm="12">
                <Form>
                    {/* content type */}
                    <div className="setting-item">
                        <Row className="g-2 align-items-center">
                            <Col md="2">
                                <h6>Content Type</h6>
                                <p>Required</p>
                            </Col>
                            <Col md>
                                <Select
                                    className="custom-select"
                                    id="basic-select-single"
                                    onChange={option => setInventoryCampaign({ ...inventoryCampaign, content_type: option.value })}
                                    value={inventoryCampaign?.content_type || null}
                                    options={contentTypes}
                                    placeholder={contentTypes.find(type => type.value === inventoryCampaign?.content_type)?.label}
                                />
                            </Col>
                        </Row>
                    </div>
                    {/* content title */}
                    <TextInput
                        label="Content Title"
                        value={inventoryCampaign?.tagline || ''}
                        onChange={e => setInventoryCampaign({ ...inventoryCampaign, tagline: e.target.value })}
                        required={true}
                        placeholder="Enter title"
                    />
                    {/* description */}
                    <TextInput
                        isTextarea={true}
                        label="Description"
                        value={inventoryCampaign?.custom_description || ''}
                        onChange={e => setInventoryCampaign({ ...inventoryCampaign, custom_description: e.target.value })}
                        required={true}
                        placeholder="Enter description"
                    />
                    {/* content image */}
                    <LogoUpload
                        onLogoChange={onLogoChange}
                        logoInputRef={logoInputRef}
                        croppedLogoPreview={croppedImagePreview}
                        logoFile={inventoryCampaign?.img_lg || null}
                        dimensions={dimensionsToUse[0]}
                        title="Content Image"
                        customTitle="Upload Image"
                        titleStyle={{ width: '95px' }}
                        guidelineUrl="https://help.hoteltechreport.com/en/articles/12455245-content-auctions#h_29e2da1ab8"
                    />
                    {/* landing page url */}
                    <Row className="mt-3">
                        <Col sm="12">
                            <div className="divider mt-2">
                                <span>{landingPageUrl}</span>
                            </div>
                        </Col>
                        <Col sm="12" className="text-center">
                            <Form className="row align-items-center">
                                <div className="col-12">
                                    <div className="input-group">
                                        <Form.Control
                                            type="url"
                                            id="landingPageLink"
                                            placeholder="Enter landing page url"
                                            value={inventoryCampaign?.custom_url || ''}
                                            onChange={onChangeCustomUrl}
                                            isInvalid={inventoryCampaign?.custom_url?.length > 255 || inventoryCampaign?.custom_url?.includes(' ')}
                                        />
                                    </div>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </>
    )
})
